import myaccount from "~/components/common/myaccount.module.scss";
import { useConfiguration } from "~/contexts/configuration";
import useSubscriptions from "~/hooks/use-subscriptions";

import LoyaltyCard from "./loyalty-card";
import PurchasesCard from "./purchases-card";
import RewardsCard from "./rewards-card";
import StoresCard from "./stores-card";

export default function Dashboard() {
  const { hasLoyaltyProgram, isUserSubscribedToLoyalty } = useSubscriptions();
  const { configuration } = useConfiguration();

  return (
    <div className={myaccount.dashboardGrid}>
      <div className={myaccount.loyaltyStoreWrapper}>
        {hasLoyaltyProgram ? <LoyaltyCard /> : null}
        {configuration["App:Ecommerce:EnabledPreferredStores"] === "true" && <StoresCard />}
      </div>
      <PurchasesCard />
      {isUserSubscribedToLoyalty && <RewardsCard onlyAvailable />}
    </div>
  );
}
